export const zhCnLocale = {
  model: {
    page: '页面'
  },
  page: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    slug: 'Slug',
    title: '标题',
    type: '类型',
    applicationId: '应用ID',
    viewsCount: '浏览数',
    miniProgramPath: '小程序路径',
    wxacode: '小程序码',
    content: '内容',
  }
}

export const enLocale = {
  model: {
    page: 'Page'
  },
  page: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    slug: 'Slug',
    title: 'Title',
    type: 'Type',
    applicationId: 'Application',
    viewsCount: 'Views count',
    miniProgramPath: 'Mini program path',
    wxacode: 'Wxacode',
    content: 'Content',
  }
}

